import React from "react";
import { SingleSelectionTab } from "./components/SingleSelectionTab/SingleSelectionTab";
import { ResultingListTab } from "./components/ResultListTab/ResultingListTab";
import { TabContent } from "reactstrap";
import { useTechnicalDesignInputMode, useProductOutput } from "stores/product";
import { TechnicalPropertiesTabs } from "./components/TechnicalPropertiesTabs/TechnicalPropertiesTabs";
import tabStyles from "./components/TechnicalPropertiesTabs/TechnicalPropertiesTabs.module.scss";
import styles from "./components/ProductConfigurationResultMainView.module.scss";
import cx from "classnames";
import { ProductMedia } from "../Media/ProductMedia";
import { useDeviceType } from "components/Layout/useDeviceType";

export const TechnicalProperties = () => {
  const technicalDesignInputMode = useTechnicalDesignInputMode();
  const productOutput = useProductOutput();
  const deviceType = useDeviceType();

  return (
    <div
      className={cx("d-flex flex-column flex-xxl-row w-100 gap-3", {
        "h-100": deviceType === "desktop",
      })}
    >
      <div
        className={"d-flex flex-column h-100 flex-grow-1"}
        style={{ minWidth: 0 }}
      >
        {productOutput?.product?.listViewConfiguration?.targetProperties && (
          <div className={tabStyles.tabsCell}>
            <TechnicalPropertiesTabs />
          </div>
        )}
        <div className={cx(styles.mainContent, "bg-white pb-3")}>
          <TabContent
            className="h-100 w-100 overflow-auto"
            activeTab={technicalDesignInputMode}
          >
            <SingleSelectionTab />
            <ResultingListTab />
          </TabContent>
        </div>
      </div>
      <ProductMedia />
    </div>
  );
};
